import { cabecera } from './cabecera';

export const referrer = r => {
  const ret = [];
  Object.entries(cabecera).forEach(([key, value]) => {
    if (r.includes(cabecera[key].c)) {
      ret.push(key);
    }
  });
  return ret[0] ? cabecera[ret[0]] : cabecera.gj;
};



// WEBPACK FOOTER //
// ./src/utils/referrer.js